module.exports = __webpack_public_path__ + "media/images/icons/drag-6b7f9f29ed9c660cacdbec9a63bf099a.svg";